// extracted by mini-css-extract-plugin
export var button = "_c2-7";
export var buttonRow = "_c2-6";
export var fadeIn = "_c2-1";
export var gradient = "_c2-0";
export var panel = "_c2-2";
export var panelIn = "_c2-3";
export var subtitle = "_c2-5";
export var title = "_c2-4";